import React, { useEffect, useState } from 'react';
import store from '@/stores/store';
import { Dimensions, View } from 'react-native';
import { Text } from '@/components/Text';
import { ConfirmDialog } from '@/components/ui/shared/Dialog';
import ConfettiCannon from 'react-native-confetti-cannon';
import { logError } from '@/utils/logHandling';
import { IS_WEB } from '@/utils/platform';
import { useStoreState } from '@/stores/store';
import constants, { isPatientApp } from '@/config/constants';
import encryptedStorage from '@/stores/encryptedStorage';

import { styles } from '@/components/ui/therapist/NewUIModal/styles';

export const NEW_UI_MODAL_KEY = 'new_ui_modal_shown';

const NewUIModal: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [showConfetti, setShowConfetti] = useState<boolean>(false);
  const { width, height } = Dimensions.get('window');
  const { isTherapistDemo } = useStoreState((state) => state);

  useEffect(() => {
    const checkIfModalShown = async () => {
      try {
        const hasSeenInStore = await store.getState().hasSeenNewUIModal;
        const hasSeenInStorage =
          await encryptedStorage().getItem('hasSeenNewUIModal');
        const hasSeen = hasSeenInStore || hasSeenInStorage;

        if (!hasSeen) {
          await store.getActions().setHasSeenNewUIModal(true);
          await encryptedStorage().setItem('hasSeenNewUIModal', true);
          setIsVisible(true);
          setTimeout(() => setShowConfetti(true), 500);
        }
      } catch (err) {
        logError('Error checking modal flag:', err);
      }
    };

    checkIfModalShown();
  }, []);

  if (isPatientApp || constants.appVersion !== '1.10.25' || isTherapistDemo) {
    return;
  }

  if (IS_WEB) {
    const currentUrlParams = new URLSearchParams(window.location.search);
    if (currentUrlParams.get('demoStarten') === 'true') {
      return;
    }
  }

  const handleClose = async () => {
    try {
      await store.getActions().setHasSeenNewUIModal(true);
      await encryptedStorage().setItem('hasSeenNewUIModal', true);
    } catch (err) {
      logError('Error saving modal flag:', err);
    }
    setShowConfetti(false);
    setIsVisible(false);
  };

  return (
    <ConfirmDialog
      isVisible={isVisible}
      headerText="🎉 Neues Design und neue Features!"
      confirmAction={handleClose}
    >
      <View style={styles.modalContent}>
        {showConfetti && (
          <View
            pointerEvents="none"
            style={{
              position: 'absolute',
              top: -300,
              left: IS_WEB ? -(width * 0.22) : -180,
              width,
              height,
            }}
          >
            <ConfettiCannon
              count={200}
              origin={{ x: 0, y: 0 }}
              fadeOut
              autoStart
            />
          </View>
        )}
        <View>
          <Text style={styles.bullets}>
            •{' '}
            <Text style={{ fontWeight: 'bold' }}>
              Vorsprechgeschwindigkeit ändern
            </Text>{' '}
            – für das Eigentraining Ihrer Patient:innen{'\n'}
          </Text>
          <Text style={styles.bullets}>
            • <Text style={{ fontWeight: 'bold' }}>Neue Wortart: Floskeln</Text>{' '}
            – alltagsnahe Redewendungen, einfach und praktisch{'\n'}
          </Text>
          <Text style={styles.bullets}>
            •{' '}
            <Text style={{ fontWeight: 'bold' }}>
              Neue Satzart: Verb-Objekt
            </Text>{' '}
            – mehr Vielfalt für noch bessere Individualisierung
          </Text>
        </View>
        <View style={styles.description}>
          <Text>
            Es kommt noch besser: Das ist bloß der Anfang eines umfangreichen
            Updates hin zu noch schnellerer Bedienbarkeit und besserer
            Individualisierung.
          </Text>
        </View>
      </View>
    </ConfirmDialog>
  );
};

export default NewUIModal;
